/**
 * MailboxAvatar — small avatar for a mailbox object.
 * Props: mailbox ({ name, avatar_url, dicebear_avatar_url }), size (number, default 28)
 */

import { h } from 'preact'

export function MailboxAvatar({ mailbox, size = 28 }) {
  const initials = (mailbox.name || '?').slice(0, 2).toUpperCase()
  const style = { width: size, height: size, borderRadius: '50%', overflow: 'hidden', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }

  if (mailbox.avatar_url) {
    return <img src={mailbox.avatar_url} alt={mailbox.name} style={{ ...style, objectFit: 'cover' }} />
  }
  if (mailbox.dicebear_avatar_url) {
    return <img src={mailbox.dicebear_avatar_url} alt={mailbox.name} style={{ ...style, objectFit: 'cover' }} />
  }
  return (
    <span class="avatar-initials" style={{ ...style, fontSize: Math.max(8, Math.round(size * 0.4)) }}>
      {initials}
    </span>
  )
}
